// extracted by mini-css-extract-plugin
module.exports = {"BusinessInfo":"borroweinfo_BusinessInfo__1p9rD","Title":"borroweinfo_Title__22uNS","ActionBar":"borroweinfo_ActionBar__1UMXn"};